import React, { useEffect, useState } from "react";
import { Grid, Button, Card, Switch, FormControlLabel, Typography } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { RECUPERO } from "../../../../utils/permisos";
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import AccionesGenericoAbm from "../../../compartidos/abms/AccionesGenericoAbm";
import FormRecupero from "./FormRecupero";
import { useForm } from "../../../../hooks/useForm";
import moment from 'moment';
import { AutorizacionesBuscador } from "../../Ingreso/AutorizacionesBuscador";
import { eliminarRecupero, fetchRecupero, guardarRecupero } from "../../../../actions/autorizaciones/abmRecupero";
import AlertDialogSlide from "../../../ui/AlertaConfirm";
import InfoHistorialIcon from "../../UI/InfoHistorialIcon";
import ModalHistoricoTrackingRecupero from "./ModalHistoricoTrackingRecupero";


const stateInitial = {
    mostrarInactivos: false
};

export const HomeRecupero = () => {
  const { afiliadoSeleccionado, recupero: items = [] } = useSelector((state) => state.autorizaciones);
  
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openModalAlta, setOpenModalAlta] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [openModalTracking, setOpenModalTracking] = useState(false);
  const [itemForm, setItemForm] = useState(false);
  const [idClave, setIdClave] = useState(false);

  const [formValues, , , setearValor] = useForm(stateInitial);
  const { mostrarInactivos } = formValues;

  useEffect(() => {
    if(afiliadoSeleccionado?.id_afiliado) 
      dispatch(fetchRecupero(afiliadoSeleccionado?.id_afiliado));
  }, [dispatch, afiliadoSeleccionado?.id_afiliado]);

  const handleItemSelect = (item) => {
    setItemForm(item)
    setOpen(true)
  }

  const handleSave = (item) => {
    const data = {
      fechaFin: item.fechaFin,
      fechaInicio: item.fechaInicio,
      idAfiliado: afiliadoSeleccionado?.id_afiliado,
    }

    dispatch(guardarRecupero(item?.id, data, item?.id ? setOpen : setOpenModalAlta));
  };

  const handleDecision = (decicion) => {
    if(decicion==='SI'){
      dispatch(eliminarRecupero(itemForm.id, setOpenModalConfirm));
    }else{
      setItemForm(null);
      setOpenModalConfirm(false);
    }
  }

  const handleDelete = (item) => {
    setItemForm(item);
    setOpenModalConfirm(true);
  }

  const intialValue = {
    fechaInicio: new Date(),
    fechaFin: ''
  }
  const title = 'Recupero';

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title={`Agregar ${title}`} open={openModalAlta} setOpen={setOpenModalAlta}>
          <FormRecupero formData={intialValue} handleSave={handleSave} cerrarModal={() => setOpenModalAlta(false)} permisoAlta={RECUPERO.ALTA} editando={false} />
        </ModalAbm>
        <ModalAbm title={`Modificar ${title}`} open={open} setOpen={setOpen}>
          <FormRecupero formData={itemForm} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={RECUPERO.MODIFICACION} editando={true} />
        </ModalAbm>
        <Grid item xs={12}>
          <Button 
            color="primary" 
            variant="contained" 
            onClick={() => setOpenModalAlta(true)} 
            disabled={!afiliadoSeleccionado?.id_afiliado}
            style={{ float: "right", marginTop: "1rem" }}
          >
            {`+ Agregar ${title}`}
          </Button>
        </Grid>
        <Grid item xs={12} md={5}>
          <Card style={{paddingRight: 10}}>
            <Typography style={{ marginLeft: 15, marginTop: 15 }} ><strong>{'Buscar Afiliado'}</strong></Typography>
            <AutorizacionesBuscador hideTitle={true} altaBaja={mostrarInactivos ? 'Todos' : 'Alta'} />
          </Card>
        </Grid>
        <AlertDialogSlide 
          open={openModalConfirm}
          setOpen={setOpenModalConfirm}
          handleDecision={handleDecision}
          mensaje={'¿Esta Seguro que desea eliminar el recupero?'}
        />

        <Grid item xs={12} md={3} style={{marginTop: "40px", marginLeft: 50}}>
          <Card style={{padding: '10px 10px 10px 25px'}}>
            <FormControlLabel
              control={
              <Switch
                checked={mostrarInactivos}
                onChange={(e) => setearValor("mostrarInactivos", e.target.checked)}
              />
              }
              label="Mostrar Afiliados Inactivos"
            />
          </Card>
        </Grid>

        {openModalTracking && (
          <ModalHistoricoTrackingRecupero
            open={openModalTracking}
            onClose={() => setOpenModalTracking(false)}
            idClave={idClave}
            descripcion={`Tracking ${title}`}
            
          />
        )}

        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              columns={[
                {
                  customBody: (item) => (
                    <InfoHistorialIcon
                      onClick={() => {
                        setOpenModalTracking(true);
                        setIdClave(item.idOriginal);
                      }} 
                    />
                  )
                },
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handleItemSelect}
                      permisoDelete={RECUPERO.BAJA}
                      handleDelete={handleDelete}
                      marginLeft={50}
                      showSelect={item.fechaBaja === null && item.id === Math.max(...items.map(i => i.id))}
                      // showSelect={item.fechaBaja === null}
                      showDelete={true}
                      // showDelete={item.fechaBaja === null}
                    />
                  )
                },
                {
                  label: "Fecha Inicio",
                  id: "fechaInicio",
                  sort: true,
                  customBody: (item) => item.fechaInicio ? moment(item.fechaInicio).format('DD/MM/YYYY') : ""
                },
                {
                  label: "Fecha Fin",
                  id: "fechaFin",
                  sort: true,
                  customBody: (item) => item.fechaFin ? moment(item.fechaFin).format('DD/MM/YYYY') : ""
                },
                {
                  label: "Usuario",
                  id: "usuario",
                  sort: true,
                  customBody: (item) => item.usuario.userName
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );

};

export default HomeRecupero; 
